export class ListItem {
  constructor(data) {
    this.value = data.value;
    this.label = data.label;
  }
}
